import { Component, OnDestroy, OnInit, OnChanges, ViewChild, ChangeDetectorRef, ElementRef, Input, Pipe, PipeTransform, Output, EventEmitter, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { UntypedFormBuilder, Validators, ControlContainer, FormGroupDirective, FormControl, UntypedFormGroup } from '@angular/forms';
import { Subject, Observable } from 'rxjs';
import { DatePipe , Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { VendorService } from '../../services/vendor.service';
import { PaymentsService } from '../../services/payments.service';
import { GlobalsService } from '../../services/globals.service';
import { GlobalSearchService } from '../../services/globalsearchservice.service';
import { MatDialog } from '@angular/material/dialog';
import { GlPreviewModalComponent, GlPreviewModalData } from '../../shared/gl-preview-modal/gl-preview-modal.component';
import {
	VendorRemitPreviewModalComponent,
	VendorRemitPreviewModalData,
	VendorRemitPreviewTabRequest
} from '../../shared/vendor-remit-preview-modal/vendor-remit-preview-modal.component';

@Component({
	selector: 'app-vendor-payment-entry',
	templateUrl: './vendor-payment-entry.component.html',
	styleUrls: ['./vendor-payment-entry.component.scss']
})

//TODO - ADD TO PAYMENT CART
export class VendorPaymentEntryComponent implements OnInit, OnChanges {
	@Input() vendor;
	@Output() newvendordata = new EventEmitter<boolean>();

	private vendorSubscription: any;
	bankaccounts: any = [];
	payment_methods: any = [];
	paymentForm: UntypedFormGroup;
	payments: any = [];
	total_payments = 0.00;
	today = new Date();
	chargetype: any = 'Check';
	result: any = false;

	vendorInvoices: any[] = [];
	vendorCredits: any[] = [];
	vendorPayments: any[] = [];
	allocations_from: any[] = [];
	allocations_to: any[] = [];
	allocation_from_total = 0.00;
	allocation_to_total = 0.00;
	user: any = null;

	constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder, private vendorService: VendorService, public router: Router, private location: Location, private globalsService: GlobalsService, private globalSearchService: GlobalSearchService, private paymentsService: PaymentsService, private dialog: MatDialog) {}


	ngOnInit(): void {
		//vendor is required. Not on GL
		this.paymentForm = this.fb.group({
			payment_type: ['', Validators.required],
			bankaccount: ['', Validators.required],
			datepaid: [this.today, Validators.required],
			checkno: [''],
			reference: [''],
			description: ['', Validators.required],
			amount: [0.00, Validators.required],
			discount: [0, Validators.required],
		});

		this.globalSearchService.bankaccounts.subscribe((accounts: any) => {
			this.bankaccounts = accounts
			if (accounts) {
				this.paymentForm.get('bankaccount').setValue(accounts[0].accountcode);
			}
		});
		this.globalSearchService.payment_methods.subscribe((payment_methods: any) => {
			this.payment_methods = payment_methods
			if (payment_methods) {
				this.paymentForm.get('payment_type').setValue(payment_methods[0].paymentname);
			}
		});

		this.globalSearchService.user.subscribe((result: any) => {
			this.user = result;
		});

		if (this.vendor && this.vendor.supplierid) {
			this.loadVendorTransactions();
		}
	}

	ngOnChanges() {
		if (this.vendor && this.vendor.supplierid) {
			this.loadVendorTransactions();
		}
	}

	addPayment() {
		if (this.paymentForm.valid) {

			this.payments.push(this.paymentForm.value);
			this.updateTotals();

			this.globalSearchService.showNotification('Payment added to batch', 'success', 'bottom', 'right');
			this.paymentForm.get('amount').setValue(0.00);
			this.paymentForm.get('checkno').setValue('');
			this.paymentForm.get('discount').setValue(0);
		} else {
			this.globalSearchService.getFormValidationErrors(this.paymentForm);
		}
	}

	setChargeType(event: any) {
		this.chargetype = event.value
		this.updatePaymentType(event.value)
	}

	updatePaymentType(method : any) {
		this.paymentForm.get('payment_type').setValue(method);
	}

	openGlPreview(): void {
		if (!this.payments.length) {
			this.globalSearchService.showNotification('Add at least one payment to the batch to preview GL.', 'info', 'bottom', 'right');
			return;
		}
		if (!this.vendor || !this.vendor.supplierid) {
			this.globalSearchService.showNotification('Vendor is required.', 'warning', 'bottom', 'right');
			return;
		}
		const payments = this.payments.map((p: any) => ({
			...p,
			amount: this.getPaymentTotal(p),
			discount: 0,
		}));
		this.dialog.open(GlPreviewModalComponent, {
			width: '1160px',
			maxWidth: '98vw',
			panelClass: 'gl-preview-dialog-panel',
			data: {
				title: 'Vendor payment — GL preview',
				getPreview: (_excludeTypenos?: number[], _sampleScope?: 'all' | 'current_year') =>
					this.paymentsService.previewVendorPaymentGl({ vendor: this.vendor, payments }),
			} as GlPreviewModalData,
		});
	}

	openRemittancePreview(): void {
		if (!this.payments.length) {
			this.globalSearchService.showNotification('Add at least one payment to the batch first.', 'info', 'bottom', 'right');
			return;
		}
		if (!this.vendor || !this.vendor.supplierid) {
			this.globalSearchService.showNotification('Vendor is required.', 'warning', 'bottom', 'right');
			return;
		}
		const allocations = this.buildRemitAllocationsForVendor();
		if (!allocations.length) {
			this.globalSearchService.showNotification('Select invoices and enter allocations before previewing the remittance email.', 'info', 'bottom', 'right');
			return;
		}
		const currency = this.vendor.currcode || 'USD';
		const tabs: VendorRemitPreviewTabRequest[] = this.payments.map((pay: any, i: number) => ({
			label: `Payment ${i + 1} (${pay.payment_type || 'Payment'})`,
			supplier_id: this.vendor.supplierid,
			context: {
				payment_total: this.getPaymentTotal(pay),
				payment_discount: parseFloat(pay.discount) || 0,
				payment_reference: pay.reference || '',
				checkno: pay.checkno || '',
				payment_type: pay.payment_type || '',
				post_date: this.formatRemitPostDate(pay.datepaid),
				bank_account: pay.bankaccount || '',
				currency
			},
			allocations
		}));
		this.dialog.open(VendorRemitPreviewModalComponent, {
			width: '760px',
			maxWidth: '98vw',
			data: {
				title: 'Remittance email preview (same as sent after Post Payments)',
				tabs
			} as VendorRemitPreviewModalData
		});
	}

	private buildRemitAllocationsForVendor(): Array<{ trans_id: number; amount: number }> {
		const out: Array<{ trans_id: number; amount: number }> = [];
		const vid = this.vendor?.supplierid;
		if (!vid) return out;
		for (const inv of this.allocations_to || []) {
			const sid = inv.supplierid != null ? inv.supplierid : inv.supplierno;
			if (String(sid) !== String(vid)) continue;
			const allocationAmount = parseFloat(inv.allocation) || 0;
			const discountAmount = parseFloat(inv.discount) || 0;
			const total = Math.round((allocationAmount + discountAmount) * 100) / 100;
			if (total > 0 && inv.id != null) {
				out.push({ trans_id: +inv.id, amount: total });
			}
		}
		return out;
	}

	private formatRemitPostDate(d: any): string {
		if (d instanceof Date) {
			return d.toISOString().slice(0, 10);
		}
		if (typeof d === 'string' && d.length >= 10) {
			return d.slice(0, 10);
		}
		return new Date().toISOString().slice(0, 10);
	}

	postPayments() {
		if (this.payments.length) {
			const allocation_data = { to: this.allocations_to };
			const data = { payments: this.payments, vendor: this.vendor, to: this.allocations_to }
			this.paymentsService.addVendorPayment(data).subscribe(result => {
				this.result = result
				this.globalSearchService.showNotification('Payment added', 'success', 'bottom', 'right');
				this.payments = [];
				this.paymentForm.get('description').setValue('');
				this.paymentForm.get('amount').setValue(0.00);
				this.paymentForm.get('discount').setValue(0);
				this.paymentForm.get('reference').setValue('');
				this.paymentForm.markAsUntouched();
				this.allocations_from = [];
				this.allocations_to = [];
				this.allocation_from_total = 0;
				this.allocation_to_total = 0;
				this.loadVendorTransactions();
				this.newvendordata.emit(this.vendor.supplierid);
			});
		}
	}

	removePayment(payment: any) {
		const index = this.payments.indexOf(payment);
		this.payments.splice(index, 1);
		this.updateTotals();
	}

	updatePaymentAmount(value: any, payment: any) {
		const index = this.payments.indexOf(payment);
		this.payments[index].amount = value;
	}
	getPaymentTotal(pay: any) {
		const discount = parseFloat(pay.amount) * (parseFloat(pay.discount) / 100);
		return (parseFloat(pay.amount) - discount);
	}

	updateTotals() {
		this.total_payments = this.payments.reduce(function(accumulator: number, payments: any) {
			const discount = parseFloat(payments.amount) * (parseFloat(payments.discount) / 100);
			return accumulator + (parseFloat(payments.amount) - discount);
		}, 0);
	}

	ngAfterViewInit() {
		//defaults
	}

	loadVendorTransactions() {
		if (this.vendor && this.vendor.supplierid) {
			this.paymentsService.getVendorAccountPayables(this.vendor.supplierid).subscribe((results: any) => {
				this.vendorInvoices = results.invoices || [];
				this.vendorCredits = results.credits || [];
				this.vendorPayments = results.payments || [];

				this.vendorInvoices.forEach((inv: any) => {
					inv.allocation = 0;
					inv.selected = false;
				});

				this.vendorCredits.forEach((cred: any) => {
					cred.allocation = 0;
					cred.selected = false;
				});

				this.vendorPayments.forEach((pay: any) => {
					pay.allocation = 0;
					pay.selected = false;
				});
			});
		}
	}

	allocationFrom(event: boolean, transaction: any) {
		if (!event) {
			const index = this.allocations_from.indexOf(transaction);
			if (index >= 0) {
				this.allocations_from.splice(index, 1);
				transaction.allocation = 0;
			}
		} else {
			if (this.allocations_from.indexOf(transaction) < 0) {
				this.allocations_from.push(transaction);
				transaction.allocation = transaction.leftto;
			}
		}
		this.updateAllocationTotals();
	}

	allocationTo(event: boolean, transaction: any) {
		if (!event) {
			const index = this.allocations_to.indexOf(transaction);
			if (index >= 0) {
				this.allocations_to.splice(index, 1);
				transaction.allocation = 0;
			}
		} else {
			if (this.allocations_to.indexOf(transaction) < 0) {
				this.allocations_to.push(transaction);
				transaction.allocation = transaction.leftto;
			}
		}
		this.updateAllocationTotals();
	}

	updateAllocationFrom(value: string, transaction: any) {
		const index = this.allocations_from.indexOf(transaction);
		if (index >= 0) {
			const amount = parseFloat(value) || 0;
			if (amount > parseFloat(transaction.leftto)) {
				transaction.allocation = parseFloat(transaction.leftto);
			} else {
				transaction.allocation = amount;
			}
		}
		this.updateAllocationTotals();
	}

	updateAllocationTo(value: string, transaction: any) {
		const index = this.allocations_to.indexOf(transaction);
		if (index >= 0) {
			const amount = parseFloat(value) || 0;
			if (amount > parseFloat(transaction.leftto)) {
				transaction.allocation = parseFloat(transaction.leftto);
			} else {
				transaction.allocation = amount;
			}
		}
		this.updateAllocationTotals();
	}

	updateAllocationTotals() {
		this.allocation_from_total = this.allocations_from.reduce(function(accumulator: number, transaction: any) {
			return accumulator + parseFloat(transaction.allocation || 0);
		}, 0);

		this.allocation_to_total = this.allocations_to.reduce(function(accumulator: number, transaction: any) {
			return accumulator + parseFloat(transaction.allocation || 0);
		}, 0);
	}

	allocatePayments() {
		if (this.allocations_from.length === 0 || this.allocations_to.length === 0) {
			this.globalSearchService.showNotification('Please select payments/credits and invoices to allocate', 'warning', 'bottom', 'right');
			return;
		}

		const from_transactions = this.allocations_from.map((t: any) => {
			return {
				id: t.id,
				supplierid: t.supplierno || this.vendor.supplierid,
				allocation: t.allocation || 0
			};
		});

		const to_transactions = this.allocations_to.map((t: any) => {
			return {
				id: t.id,
				supplierid: t.supplierno || this.vendor.supplierid,
				allocation: t.allocation || 0
			};
		});

		const userid = this.user && this.user.user ? this.user.user.userid : '';

		const data = {
			from: from_transactions,
			to: to_transactions,
			vendor: this.vendor,
			userid: userid
		};

		this.paymentsService.addVendorPaymentAllocations(data).subscribe((result: any) => {
			if (result.success) {
				this.globalSearchService.showNotification('Allocations processed successfully', 'success', 'bottom', 'right');
				this.allocations_from = [];
				this.allocations_to = [];
				this.allocation_from_total = 0;
				this.allocation_to_total = 0;
				this.loadVendorTransactions();
				this.newvendordata.emit(this.vendor.supplierid);
			} else {
				this.globalSearchService.showNotification('Error processing allocations', 'error', 'bottom', 'right');
			}
		}, (error: any) => {
			this.globalSearchService.showNotification('Error processing allocations', 'error', 'bottom', 'right');
		});
	}

}
